import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  mutation RefreshOrdersFromSidekick($input: RefreshOrdersFromSidekickInput!) {
    refreshOrdersFromSidekick(input: $input) {
      orders {
        ...OrderRow
      }
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/refreshOrdersFromSidekick.js